import type { CSSProperties } from 'react';
import React from 'react';
import { createFromIconfontCN } from '@ant-design/icons';

type TIconFontProps = {
  onMouseLeave?: (event: React.MouseEvent<HTMLSpanElement>) => void;
  onMouseOver?: (event: React.MouseEvent<HTMLSpanElement>) => void;
  onClick?: (event: React.MouseEvent<HTMLSpanElement>) => void;
  className?: string;
  style?: CSSProperties;
  type: string;
  scriptUrl?: string; // 在线的iconfont图片url地址
};

const IconFont: React.FC<TIconFontProps> = (props) => {
  const {
    onMouseLeave,
    onMouseOver,
    onClick,
    style,
    className,
    type,
    scriptUrl = '//at.alicdn.com/t/c/font_4440958_us6op2078ib.js',
  } = props;
  let iconType = type;
  if (!iconType.startsWith('icon-')) {
    iconType = `icon-${type}`;
  }
  const createFontIcon = () => {
    return createFromIconfontCN({
      scriptUrl: [scriptUrl],
    });
  };
  const OnlineFontIcon = createFontIcon();
  return (
    <OnlineFontIcon
      {...props}
      className={className}
      style={style}
      type={iconType}
      onMouseDown={onClick}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
    />
  );
};
export default IconFont;
